import React from 'react';
import { useParams } from 'react-router-dom';
import ImportView from './ImportView/ImportView';
import ProjectView from './ProjectView/ProjectView';

export default () => {
    const { areaName } = useParams();

    return areaName === 'import' ? <ImportView /> : <ProjectView />;
};
